import { Link, Text } from '@tonic-one/react';
import { Trans } from 'react-i18next';
import customConfig from 'src/config';
import { PolicyType } from '../../../../types/app';
import { THIRD_PARTY_LINK } from '@Utils/casDocLink';
import AddInPanel from '../AddInPanel';

const OutlookAddIn = () => {
  return (
    <AddInPanel
      policyTypes={[PolicyType.Exchange, PolicyType.ExchangeInline]}
      descriptionContent={
        <Text>
          <Trans
            i18nKey="administration.addIn.content"
            values={{
              url: customConfig.ui.administrator.addInInstallLink,
            }}
          >
            placeholder
            <Link href={THIRD_PARTY_LINK.addInIntegratedApps} target="_blank">
              placeholder
            </Link>
            <Link
              display="inline-block"
              target="_blank"
              href={customConfig.ui.administrator.addInInstallLink}
            ></Link>
          </Trans>
        </Text>
      }
    />
  );
};

export default OutlookAddIn;
